import { Button, Checkbox, Heading, Pane, SelectField, TextInputField, Label } from 'evergreen-ui';
import { Formik } from 'formik';
import React, { Component } from 'react';

const DAYS_OF_WEEK = [
    { key: 'monday', label: 'Luni' },
    { key: 'tuesday', label: 'Marți' },
    { key: 'wednesday', label: 'Miercuri' },
    { key: 'thursday', label: 'Joi' },
    { key: 'friday', label: 'Vineri' },
    { key: 'saturday', label: 'Sâmbătă' },
    { key: 'sunday', label: 'Duminică' }
];

const COLOR_OPTIONS = [
    { value: '#3174ad', label: 'Albastru' },
    { value: '#4CAF50', label: 'Verde' },
    { value: '#f44336', label: 'Roșu' },
    { value: '#ff9800', label: 'Portocaliu' },
    { value: '#9c27b0', label: 'Mov' },
    { value: '#00bcd4', label: 'Cyan' },
    { value: '#795548', label: 'Maro' },
    { value: '#607d8b', label: 'Gri' }
];

export default class ShopForm extends Component {
    render() {
        return (
            <Formik
                initialValues={this.props.initialValues}
                enableReinitialize={true}
                validationSchema={this.props.validationSchema}
                validateOnChange={false}
                validateOnBlur={false}
                onSubmit={(values) => {
                    this.props.onSave(values);
                }}
            >
                {({ errors, handleChange, handleBlur, handleSubmit, values, setFieldValue }) => {
                    errors = Object.assign({}, this.props.errors, errors);

                    return (
                        <form>
                            <Pane display="flex" gap={16}>
                                <Pane flex={1}>
                                    <TextInputField
                                        required
                                        label="Nume Magazin"
                                        name="name"
                                        description="Numele magazinului"
                                        value={values.name || ""}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        validationMessage={errors.name}
                                    />

                                    <TextInputField
                                        label="Adresă"
                                        name="address"
                                        description="Adresa completă a magazinului"
                                        value={values.address || ""}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        validationMessage={errors.address}
                                    />

                                    <Pane display="flex" gap={16}>
                                        <Pane flex={1}>
                                            <TextInputField
                                                label="Telefon"
                                                name="phone"
                                                value={values.phone || ""}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                validationMessage={errors.phone}
                                            />
                                        </Pane>
                                        <Pane flex={1}>
                                            <TextInputField
                                                label="Email"
                                                name="email"
                                                type="email"
                                                value={values.email || ""}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                validationMessage={errors.email}
                                            />
                                        </Pane>
                                    </Pane>

                                    <Pane display="flex" gap={16}>
                                        <Pane flex={1}>
                                            <TextInputField
                                                required
                                                label="Personal Minim/Tură"
                                                name="minStaffPerShift"
                                                type="number"
                                                min={1}
                                                description="Numărul minim de angajați necesari în orice moment"
                                                value={values.minStaffPerShift || 2}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                validationMessage={errors.minStaffPerShift}
                                            />
                                        </Pane>
                                        <Pane flex={1}>
                                            <SelectField
                                                label="Culoare Calendar"
                                                name="color"
                                                value={values.color || '#3174ad'}
                                                onChange={handleChange}
                                            >
                                                {COLOR_OPTIONS.map(opt => (
                                                    <option key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </SelectField>
                                        </Pane>
                                    </Pane>

                                    <Checkbox
                                        label="Magazin Activ"
                                        name="active"
                                        checked={values.active}
                                        onChange={(e) => setFieldValue('active', e.target.checked)}
                                    />
                                </Pane>
                            </Pane>

                            <Pane marginTop={24}>
                                <Heading size={500} marginBottom={16}>Program de Funcționare</Heading>
                                
                                <Pane background="tint1" padding={16} borderRadius={4}>
                                    {DAYS_OF_WEEK.map(day => (
                                        <Pane 
                                            key={day.key} 
                                            display="flex" 
                                            alignItems="center" 
                                            gap={16} 
                                            marginBottom={8}
                                            paddingY={8}
                                            borderBottom="muted"
                                        >
                                            <Pane width={100}>
                                                <Label>{day.label}</Label>
                                            </Pane>
                                            
                                            <Checkbox
                                                label="Închis"
                                                checked={values.operatingHours?.[day.key]?.closed || false}
                                                onChange={(e) => {
                                                    setFieldValue(`operatingHours.${day.key}.closed`, e.target.checked);
                                                }}
                                            />
                                            
                                            {!values.operatingHours?.[day.key]?.closed && (
                                                <>
                                                    <Pane display="flex" alignItems="center" gap={8}>
                                                        <Label size={300}>Deschidere:</Label>
                                                        <input
                                                            type="time"
                                                            value={values.operatingHours?.[day.key]?.open || '09:00'}
                                                            onChange={(e) => {
                                                                setFieldValue(`operatingHours.${day.key}.open`, e.target.value);
                                                            }}
                                                            style={{
                                                                padding: '8px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #d8dae5'
                                                            }}
                                                        />
                                                    </Pane>
                                                    
                                                    <Pane display="flex" alignItems="center" gap={8}>
                                                        <Label size={300}>Închidere:</Label>
                                                        <input
                                                            type="time"
                                                            value={values.operatingHours?.[day.key]?.close || '21:00'}
                                                            onChange={(e) => {
                                                                setFieldValue(`operatingHours.${day.key}.close`, e.target.value);
                                                            }}
                                                            style={{
                                                                padding: '8px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #d8dae5'
                                                            }}
                                                        />
                                                    </Pane>
                                                </>
                                            )}
                                        </Pane>
                                    ))}
                                </Pane>
                            </Pane>

                            <Pane borderTop="default" marginTop={24} paddingTop={16}>
                                <Button type="submit" appearance="primary" onClick={handleSubmit}>
                                    Salvează
                                </Button>
                            </Pane>
                        </form>
                    );
                }}
            </Formik>
        );
    }
}
